/**
 * 画面chunk取得失敗の判定と自動再読み込みの回数制御
 * デプロイ前から開いているタブは旧hashのchunkを要求するため、再読み込みで最新版へ切り替えます。
 */

/** 自動再読み込みの実施時刻を保持するsessionStorageキー */
const CHUNK_RELOAD_ATTEMPTED_AT_STORAGE_KEY = "@ikomasai/chunk_reload_attempted_at";

/** 直前の自動再読み込みから再試行を止める時間（ミリ秒） */
export const CHUNK_RELOAD_COOLDOWN_MS = 60 * 1000;

/** ブラウザ・Viteが動的import失敗時に出す例外文言 */
const CHUNK_LOAD_ERROR_PATTERNS = Object.freeze([
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Unable to preload CSS/i,
]);

/**
 * 例外が画面chunkの取得失敗かを判定する
 * @param {unknown} error - 捕捉した例外
 * @returns {boolean} chunk取得失敗ならtrue
 */
export const isChunkLoadError = (error: unknown): boolean => {
  /** 判定対象の例外文言 */
  const message = error instanceof Error ? error.message : String(error ?? "");

  return CHUNK_LOAD_ERROR_PATTERNS.some((pattern) => pattern.test(message));
};

/**
 * 自動再読み込みを1回分確保する
 * 直前の再読み込みから間もない場合や、sessionStorageを使えない場合は再読み込みの無限反復を避けるためfalseを返す。
 * @param {number} [now=Date.now()] - 現在時刻（ミリ秒）
 * @returns {boolean} 自動再読み込みしてよい場合true
 */
export const claimChunkReloadAttempt = (now: number = Date.now()): boolean => {
  try {
    /** 前回の自動再読み込み時刻 */
    const lastAttemptedAt = Number(
      window.sessionStorage.getItem(CHUNK_RELOAD_ATTEMPTED_AT_STORAGE_KEY),
    );

    if (
      Number.isFinite(lastAttemptedAt)
      && lastAttemptedAt > 0
      && now - lastAttemptedAt < CHUNK_RELOAD_COOLDOWN_MS
    ) {
      return false;
    }

    window.sessionStorage.setItem(CHUNK_RELOAD_ATTEMPTED_AT_STORAGE_KEY, String(now));
    return true;
  } catch {
    return false;
  }
};
